var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LocationSelector',{attrs:{"locations":_vm.locations,"value":_vm.value.locations},on:{"input":_vm.updateLocations}}),_c('PeriodSelector',{attrs:{"value":_vm.value.period},on:{"input":_vm.updatePeriod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }